import React from "react"
import { randomInt } from "@jsUtils"
import { CONSTANTS } from "@data"
import { Accordion, ContentRow, LinkList } from "@shared"
import { FAQJsonLd } from "gatsby-plugin-next-seo"
import { HelmetProvider } from "react-helmet-async"
import { SupportContactForm } from "../SupportContactForm"

import Styles from "./supportfaqs.module.scss"

const { THEMES, COLORS } = CONSTANTS

const SupportFaqs = content => {
  const { data, otherPages, slug } = content
  const items = data
  const faqs = []
  const helmetContext = {}

  return (
    <main role="main">
      <ContentRow gridName="heavyContentGrid" extraClass={Styles.support}>
        <div className={Styles.contentSide}>
          <ul className={Styles.categories}>
            <LinkList links={otherPages} current={slug} onStyle={Styles.current} />
          </ul>
        </div>
        <div className={Styles.contentMain}>
          {/* <Headline size={3} className={Styles.contentTitle}>
            {otherPages && otherPages.find(page => page.slug === slug).title}
          </Headline> */}
          {slug === "customer-support" && (
            <SupportContactForm theme={THEMES.LIGHT} color={COLORS.FLURO} inputVariant="box" />
          )}
          {items.map((item, i) => {
            faqs.push({ question: item.summary, answer: item.content })

            return (
              <div className={Styles.faqRow} key={`${item.id}-${randomInt(0, Date.now())}`}>
                <Accordion
                  summary={item.summary}
                  insideStyle={item.style}
                  bindEvent={i === 0}
                  useMarkup={item.content}
                  color={COLORS.FLURO}
                />
              </div>
            )
          })}

          <HelmetProvider context={helmetContext}>
            <FAQJsonLd questions={faqs} />
          </HelmetProvider>
        </div>
      </ContentRow>
    </main>
  )
}

export default SupportFaqs
